export const OFFLINE_MOCK_KEY = 'offline-mock';

export function isOfflineMockEnabled(): boolean {
  if (process.env.REACT_APP_OFFLINE_MOCK === 'true') {
    return true;
  }

  try {
    return localStorage.getItem(OFFLINE_MOCK_KEY) === 'true';
  } catch {
    return false;
  }
}
